import { clusterApiUrl } from "@solana/web3.js";

export const Config = {
    apiURL: 'https://api.etakit.in',
    SolanaCluster: 'https://wider-falling-firefly.solana-mainnet.discover.quiknode.pro/9bcba0c1c16d1435fe07126ee2790a679cdd78aa/',
    // apiURL: 'https://odd-plum-sunbonnet.cyclic.app'
}